module.exports = __webpack_public_path__ + "static/media/veloJ1_2024.824081cb.png";